import React from "react";

const Gutter = (_props: any) => {
    return <div className='col-sm-2 d-none d-lg-block'>&nbsp;</div>
};

export default Gutter;

